<template>
  <Transition name="swipe">
    <aside v-show="computedValue" class="modal">
      <SvoiModalContent :size="size" @out-click="onClose">
        <template #header>
          <slot name="header" />
        </template>

        <slot />

        <template #close>
          <slot name="close">
            <div class="close-wrapper" @click="onClose">
              <div class="close" />
            </div>
          </slot>
        </template>
      </SvoiModalContent>
    </aside>
  </Transition>
</template>

<script lang="ts">
import { ComponentPropsOptions, computed, defineComponent, isVue2, PropType } from 'vue-demi'
import { isString } from '@svoi-ui/shared/utils/guards'
import { ModalSizes } from '@svoi-ui/interfaces/modal'
import { SvoiModalContent } from './'

const modelProp: ComponentPropsOptions = isVue2
  ? {
      value: {
        type: Boolean,
        required: true
      }
    }
  : {
      modelValue: {
        type: Boolean,
        required: true
      }
    }

export default defineComponent({
  name: 'SvoiCurtainModal',
  components: { SvoiModalContent },
  props: {
    ...modelProp,
    size: {
      type: String as PropType<ModalSizes>,
      default: ModalSizes.md,
      validator: (value: unknown) => {
        return (
          isString(value) &&
          [
            ModalSizes.full.toString(),
            ModalSizes.md.toString(),
            ModalSizes.sm.toString(),
            ModalSizes.lg.toString()
          ].includes(value)
        )
      }
    }
  },
  emits: ['input', 'on-close', 'update:modelValue'],
  setup(props, { emit }) {
    const computedValue = computed({
      get() {
        // @ts-expect-error
        return isVue2 ? props.value : props.modelValue
      },
      set(val) {
        emit(isVue2 ? 'input' : 'update:modelValue', val)
      }
    })

    const onClose = () => {
      emit('on-close')

      computedValue.value = false
    }

    return { computedValue, onClose }
  }
})
</script>

<style lang="scss" scoped>
@use '@svoi-ui/assets/scss/components/modal/curtain-modal';

.swipe-enter-active {
  animation: swipe-out 0.5s reverse;
}

.swipe-leave-active {
  animation: swipe-out 0.5s;
}

@keyframes swipe-out {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
}
</style>
